export default "__VITE_ASSET__DB1fmmUG__"